export const FEATURE_FLAGS = Object.freeze({
  AI_ASSISTANT: "ai-assistant",
  NOTIFICATIONS: "notifications",
  EMAIL_AI_TRANSLATION: "email-ai-translation",
  PDF_AI_TRANSLATION: "pdf-ai-translation",
  REVIEWS: "reviews",
  ITINERARY_ONVO_PAYMENTS: "itinerary-onvo-payments",
  ORGANIZATION_BILLING: "organization-billing",
  ORGANIZATION_BILLING_ONVO: "organization-billing-onvo",
});

export const FEATURE_FLAG_DEFAULTS = Object.freeze({
  [FEATURE_FLAGS.AI_ASSISTANT]: false,
  [FEATURE_FLAGS.NOTIFICATIONS]: true,
  [FEATURE_FLAGS.EMAIL_AI_TRANSLATION]: false,
  [FEATURE_FLAGS.PDF_AI_TRANSLATION]: false,
  [FEATURE_FLAGS.REVIEWS]: true,
  [FEATURE_FLAGS.ITINERARY_ONVO_PAYMENTS]: false,
  [FEATURE_FLAGS.ORGANIZATION_BILLING]: true,
  [FEATURE_FLAGS.ORGANIZATION_BILLING_ONVO]: false,
});
